// @flow
import React, { Fragment } from 'react';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { getNavigationCallCenterButtonTrackingData } from 'Components/widgets/navigation/Navigation.tracking';

import { Button } from 'Components/frameworks/button/Button.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

export type NavigationContactProps = {
  contact?: CMSNavigationBarContact,
  hasTel?: boolean,
};

export function NavigationContact({ contact = {}, hasTel }: NavigationContactProps) {
  const { description, hours, phoneNumber = '', title = '', toll } = contact;

  const link = `tel:${phoneNumber}`;

  return (
    <Fragment>
      <Title className="mb-2" theme="title-sans-4">
        {title}
      </Title>
      <Text data-testid="NavigationContact-description" text={description} />
      {toll && (
        <p
          className="reset-paragraph font-sans text-sm leading-normal text-gray-medium"
          data-testid="NavigationContact-toll"
        >
          {toll}
        </p>
      )}
      <Text
        className="mt-3"
        color={COLORS.BLUE}
        data-testid="NavigationContact-hours"
        text={hours}
        theme="text-sans-2"
      />
      {phoneNumber &&
        hasTel && (
          <div className="flex items-center justify-center mt-5">
            <Button
              colorBg={COLORS.BOOKING}
              colorBorder={COLORS.BOOKING}
              iconLeft={{ name: ICONS.PHONE_BUBBLE }}
              trackingData={getNavigationCallCenterButtonTrackingData(phoneNumber)}
              url={link}
            >
              <span dir="ltr">{phoneNumber}</span>
            </Button>
          </div>
        )}
    </Fragment>
  );
}
